<template>
  <div
    id="FlowCrediOfferCardContainer"
    v-when-visible="triggerEventWhenElementIsVisible"
    class="FlowCrediOfferCardContainer"
  >
    <AffiliateOfferCardB
      v-if="abTest() === 'B'"
      :interest-rate="0.99"
      :max-duration="360"
      :max-amount="5000000"
      partner="FLOWCREDI"
      product-label="Imóvel em garantia"
      @action-forward-click="selectOffer"
      @brand-click="selectOffer"
      @offer-conditions-click="selectOffer"
    />
    <AffiliateOfferCard
      v-else
      :interest-rate="0.99"
      :max-duration="360"
      :max-amount="5000000"
      partner="FLOWCREDI"
      @action-forward-click="selectOffer"
      @brand-click="selectOffer"
      @offer-conditions-click="selectOffer"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import whenVisibleDirective from '@/aasgard/directives/when-visible'
import { PartnersFaq } from '~/helpers/partners/partnersFaq'
import { Partner } from '@/data/common'
import AffiliateOfferCard from '~/aasgard/components/cards/AffiliateOfferCard.vue'
import axios from 'axios'
import { abTest } from '~/helpers/abTest'
import AffiliateOfferCardB from '~/aasgard/components/cards/AffiliateOfferCardB.vue'
export default {
  name: 'FlowCrediOfferCardContainer',
  components: {
    AffiliateOfferCardB,
    AffiliateOfferCard,
  },
  directives: {
    ...whenVisibleDirective,
  },
  data() {
    return {
      displayOfferDetailsModal: false,
      busy: false,
      displayFaqsModal: false,
      offer: {
        partner: Partner.FLOWCREDI,
      },
      isSelected:
        sessionStorage.getItem(
          'jb.state.loans.home-equity.flowcredi.selected',
        ) === 'true',
    }
  },
  computed: {
    ...mapGetters({
      gtHomeEquityLatestColdOfferRequest:
        'products/loans/home-equity/cold-offer/gtHomeEquityLatestColdOfferRequest',
      gtHomeEquityExtraQuestions:
        'products/loans/home-equity/cold-offer/gtHomeEquityExtraQuestions',
      gtUser: 'user/user/gtUser',
    }),
    cptdFaq() {
      return PartnersFaq[this.offer?.partner] ?? []
    },
  },
  mounted() {
    this.actInsertIntent({
      identifier: 'PARTNER_FLOWCREDI_VIEW',
    })
    this.selectFlowCrediOffer()
  },
  methods: {
    abTest,
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
      actInsertIntent: 'user/intent/actInsertIntent',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
    }),
    triggerEventWhenElementIsVisible() {
      this.actEmitGaEvent({
        eventLabel: 'card-flowcredi',
        eventCategory: 'card-flowcredi',
        eventAction: 'result-page-visualization',
      })
    },
    async selectOffer() {
      this.busy = true
      this.actEmitGaEvent({
        eventLabel: 'card-flowcredi',
        eventCategory: 'card-flowcredi',
        eventAction: 'result-page-click',
      })

      this.actSetLastLoanInteraction('home-equity')

      this.$router.push({
        path: `/oferta/aceita/${Partner.FLOWCREDI.toLowerCase()}/id`,
      })

      this.busy = false
    },
    async selectFlowCrediOffer() {
      if (this.isSelected) return
      const flowCrediCollateralTypes = {
        comercial: 'Sala_comercial',
        terreno: 'Terreno',
        residencial: 'Casa',
      }

      try {
        const options = {
          headers: {
            'Content-Type': 'application/json',
          },
        }
        await axios.post(
          'https://gznoteshaeh76viaosgql5ymzm0ltbqr.lambda-url.us-east-2.on.aws/simulation/flowcredi',
          {
            name: this.gtUser?.name,
            cpf: this?.gtUser?.cpf,
            mobile_phone: this?.gtUser?.mobile_phone,
            email: this?.gtUser?.email,
            birth_date: this?.gtHomeEquityLatestColdOfferRequest?.birth_date,
            monthly_income:
              this?.gtHomeEquityLatestColdOfferRequest?.monthly_income,
            collateral_type:
              flowCrediCollateralTypes[
                (this?.gtHomeEquityExtraQuestions?.collateral_type || '')
                  .split(' ')[0]
                  .toLowerCase()
              ] || 'Casa',
            collateral_value:
              this?.gtHomeEquityLatestColdOfferRequest?.collateral_value,
            requested_amount:
              this?.gtHomeEquityLatestColdOfferRequest?.requested_loan_amount,
            cep: this?.gtHomeEquityLatestColdOfferRequest?.zip_code,
            is_paid: !this?.gtHomeEquityLatestColdOfferRequest?.residence_debt, // se é quitada
            outstanding_balance: this?.gtHomeEquityLatestColdOfferRequest
              ?.residence_debt
              ? this?.gtHomeEquityExtraQuestions?.outstanding_financing || 0
              : 0,
          },
          options,
        )
        this.isSelected = true
        sessionStorage.setItem('jb.state.loans.home-equity.flowcredi.selected')
      } catch (e) {}
    },
  },
}
</script>
<style lang="scss"></style>
